import { render, staticRenderFns } from "./AddDirectPurchase.vue?vue&type=template&id=1b76383c&scoped=true&"
import script from "./AddDirectPurchase.vue?vue&type=script&lang=js&"
export * from "./AddDirectPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddDirectPurchase.vue?vue&type=style&index=0&id=1b76383c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b76383c",
  null
  
)

export default component.exports